import { MODE_TRANSFER } from '@/lib/constants';
import { RouteLinkSegmentApiV4Interface, RouteTransferSegmentApiV4Interface } from '@/types/api-types';

export const getIsApiSegmentTransfer = (
  segment: RouteTransferSegmentApiV4Interface | RouteLinkSegmentApiV4Interface,
) => {
  return segment.routeType === MODE_TRANSFER;
};
